import { NavigationService } from './../services/navigation.service';
import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[backButton]',
    host: {
        class: 'uw-back-button'
    }
})
export class BackButtonDirective {
  constructor(private navigation: NavigationService) { }

  @HostListener('click')
  onClick(): void {
    this.navigation.back();
  }
}
